export default __webpack_public_path__ + "2dfe27e6bd9de5f5790d5075105ad3b1.png";